const $ = jQuery.noConflict();

function encodeQueryData(data) {
    const ret = [];
    for (let d in data)
        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
    return ret.join('&');
}

class BookBar {
    constructor() {
        this.barCta = $('.book-bar-cta');
        this.barNumber = $('.number-change');
    }
    init() {
        this.bindEvents();
    }
    bindEvents() {
        this.barCta.on('click', this.ctaClick);
        this.barNumber.on('click', this.updateNumber);
    }
    ctaClick(e){
        e.preventDefault();

        $('.invalid').removeClass('invalid');

        const hotelid = 1460;
        const baseUrl = 'https://www.reseze.net/servlet/WebresShowAvailable';
        const oneDay = 1000 * 60 * 60 * 24;

        if ($('#date_arrival').val() == '' ) {
            $('#date_arrival').addClass('invalid');
        }
        if ($('#date_departure').val() == '' ) {
            $('#date_departure').addClass('invalid');
        }
        
        if ($('.invalid').length) {
            return false;
        }

        const arrivalDate = new Date($('#date_arrival').val());
        const departureDate = new Date($('#date_departure').val());

        let props = {
            arrivalDay: arrivalDate.getUTCDate(),
            arrivalMonth: arrivalDate.getUTCMonth(),
            arrivalYear: arrivalDate.getUTCFullYear(),
            nightsStay: (departureDate - arrivalDate) / oneDay,
            numberRooms: 1,
            adults: $('#adults').val(),
            children: $('#children').val(),
            hotelid: hotelid,
            buildingCodeRoomType: 'oh|any',
        }

        const url = baseUrl + '?' + encodeQueryData(props);

        console.log('url ', url);
        window.open(url);
    }

    updateNumber(e){
        const el = e.target;
        const numberInput = $(el).parent().find('.number-input');
        let number = parseInt(numberInput.val());

        if (isNaN(number)) {
            number = 1;
        }

        if ($(el).hasClass('number-change__decrease')){
            number = number - 1;
        } else {
            number = number + 1;
        }

        if ($(numberInput).hasClass('number-input__adults') && number < 1 ) {
            number = 1;
        } else if( !$(numberInput).hasClass('number-input__adults') && number < 0 ) {
            number = 0;
        }

        $(numberInput).val(number);

        return false;
    }
}
export default new BookBar();
